const socialIcon = () => {
    return (
        <div className="social__icons">
            <a href="https://www.facebook.com/GamerZonei5" className="social-link" target="_blank" rel="noopener noreferrer"><i className="facebook icon"></i></a>
            <a href="#afzal" className="social-link" target="_blank" rel="noopener noreferrer"><i className="twitter icon"></i></a>
            <a href="https://www.linkedin.com/in/afzal-saiyed-b25004200/" className="social-link" target="_blank" rel="noopener noreferrer"><i className="linkedin icon"></i></a>
            <a href="https://www.instagram.com/afzal__saiyed/" className="social-link" target="_blank" rel="noopener noreferrer"><i className="instagram icon"></i></a>
            <a href="https://www.youtube.com/channel/UCqHpah7p2NjkLxywQfG0d-Q" className="social-link" target="_blank" rel="noopener noreferrer"><i className="youtube icon"></i></a>
            <a href="https://github.com/gmrzone" className="social-link" target="_blank" rel="noopener noreferrer"><i className="github icon"></i></a>
        </div>
    )
}

export default socialIcon